<template>
  <section class="content-block">
    <div class="mx-auto text-center">
      <h2 class="section-title">How it works</h2>

      <div class="steps">
        <div class="step">
          <div class="step__image-wrap">
            <img src="/images/emojis/link.svg" alt="link emoji" class="step__image" />
          </div>

          <h3 class="step__title">
            <span class="step__title-step">Step 1</span>
            Connect to Strava
          </h3>
          <p class="step__description">Connect Fitsnack to your Strava account to get started.</p>
        </div>

        <div class="step">
          <div class="step__image-wrap">
            <img
              src="/images/emojis/settings-gear.svg"
              alt="settings gear emoji"
              class="step__image"
            />
          </div>
          <h3 class="step__title">
            <span class="step__title-step">Step 2</span>
            Choose your snacks
          </h3>
          <p class="step__description">Pick your favorite snacks to burn with your activities.</p>
        </div>

        <div class="step">
          <div class="step__image-wrap">
            <img src="/images/emojis/bicep.svg" alt="bicep emoji" class="step__image" />
          </div>
          <h3 class="step__title">
            <span class="step__title-step">Step 3</span>
            Record your activity
          </h3>
          <p class="step__description">
            Burn calories with any activity - running, biking, or any other workout.
          </p>
        </div>

        <div class="step">
          <div class="step__image-wrap">
            <img src="/images/emojis/pizza.svg" alt="pizza emoji" class="step__image" />
          </div>
          <h3 class="step__title">
            <span class="step__title-step">Step 4</span>
            Turn sweat into snacks
          </h3>
          <p class="step__description">
            Your burned calories automatically turn into snacks, featured in your Strava posts.
          </p>
        </div>
      </div>
      <div class="flex flex-col sm:flex-row items-center justify-center gap-10">
        <ConnectToStravaButton></ConnectToStravaButton>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import ConnectToStravaButton from './ConnectToStravaButton.vue'
</script>

<style scoped>
@reference "../../../assets/css/base.css";

.steps {
  @apply my-10 md:my-16 text-left gap-6 grid  md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4;
}

.step {
  @apply flex flex-col gap-y-5 items-start justify-start p-6 rounded-2xl border border-gray-200 bg-white;
}

.step__image-wrap {
  @apply flex items-center justify-center bg-gray-50 h-10 w-10 rounded-full;
}

.step__image {
  @apply h-5;
}

.step__title {
  @apply font-bold text-lg;
}

.step__title-step {
  @apply block font-semibold text-xs text-gray-400;
}

.step__description {
  @apply text-gray-500;
}

.step-arrow-wrap {
  @apply flex items-center justify-center;
}

.step-arrow {
  @apply w-5 h-5 text-gray-500;
}
</style>
